// Minimal protobuf writer: just enough to build YouTube's `sp` filter param.

export type Field = [field: number, value: number | Field[]];

function varint(n: number): number[] {
  const out: number[] = [];
  let v = n;
  while (v > 0x7f) {
    out.push((v & 0x7f) | 0x80);
    v >>>= 7;
  }
  out.push(v);
  return out;
}

export function encode(fields: Field[]): number[] {
  const out: number[] = [];
  for (const [field, value] of fields) {
    if (typeof value === 'number') {
      out.push(...varint(field << 3), ...varint(value));
    } else {
      const body = encode(value);
      out.push(...varint((field << 3) | 2), ...varint(body.length), ...body);
    }
  }
  return out;
}

export function toBase64(bytes: number[]): string {
  return btoa(String.fromCharCode(...bytes));
}
